import React, { memo } from 'react';

import { Box, Tooltip } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelBorderStyle,
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS } from '../../../../LoanApplicationDocuments.constants';

import { documentDiscriminatorPropType } from './DocumentDiscriminatorTag.constants';
import {
  discriminatorQueryMarkSx,
  discriminatorTagWrapperSx,
  discriminatorValueSx,
} from './DocumentDiscriminatorTag.styles';
import { DocumentDiscriminatorTagTestIds } from './DocumentDiscriminatorTag.testIds';

const DocumentDiscriminatorTag = ({ discriminator, documentId }) => {
  const value = discriminator?.value;

  if (_.isNil(value) || value === '') {
    return null;
  }

  const { fieldName, belowThreshold = false } = discriminator;
  const baseTitle = fieldName ? `${fieldName}: ${value}` : value;
  const tooltipTitle = belowThreshold ? `${baseTitle} (low confidence)` : baseTitle;

  const label = (
    <>
      <Box component="span" sx={discriminatorValueSx}>
        {value}
      </Box>
      {belowThreshold && (
        <Box aria-hidden component="span" sx={discriminatorQueryMarkSx}>
          ?
        </Box>
      )}
    </>
  );

  return (
    <Tooltip PopperProps={DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS} title={tooltipTitle}>
      <Box
        aria-label={belowThreshold ? tooltipTitle : null}
        component="span"
        data-testid={DocumentDiscriminatorTagTestIds.getTagId(documentId)}
        sx={discriminatorTagWrapperSx}
      >
        <LabelCDS
          shrinkable
          borderStyle={LabelBorderStyle.DOTTED}
          size={LabelSize.S}
          title={label}
          variant={LabelVariant.BLUE_GRAY}
          withBorder={belowThreshold}
        />
      </Box>
    </Tooltip>
  );
};

DocumentDiscriminatorTag.propTypes = {
  documentId: PropTypes.string.isRequired,
  discriminator: documentDiscriminatorPropType,
};

export default memo(DocumentDiscriminatorTag);
